import type { SVGProps } from "react";
export interface Arrow04DownIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Arrow04DownIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Arrow04DownIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M14.376 4.4c0-.439 0-.7-.016-.894a1 1 0 0 0-.022-.164l-.003-.012a.38.38 0 0 0-.164-.164c.024.012.004-.01-.176-.025a13 13 0 0 0-.895-.016h-2.2c-.439 0-.701 0-.895.016-.18.015-.2.037-.176.025a.4.4 0 0 0-.095.069l-.069.095c-.005.019-.016.07-.025.176-.016.193-.016.455-.016.893V12.5c0 .621-.504 1.125-1.125 1.125H4.956l6.118 6.445.391.409c.107.108.192.193.268.26a1 1 0 0 0 .147.116.38.38 0 0 0 .24 0 1 1 0 0 0 .147-.115c.152-.136.342-.336.659-.67l6.118-6.445h-3.543a1.125 1.125 0 0 1-1.125-1.125zm2.25 6.975h3.176c.27 0 .551-.001.778.019.17.015.51.053.83.262l.135.1.14.132c.303.323.464.76.437 1.21-.028.462-.282.798-.403.95-.14.178-.335.38-.521.578l-6.64 6.994c-.29.306-.555.585-.794.798-.248.222-.545.442-.926.57a2.63 2.63 0 0 1-1.676 0c-.381-.128-.678-.348-.926-.57a14 14 0 0 1-.794-.798l-6.64-6.995c-.186-.196-.38-.399-.521-.577-.121-.152-.375-.488-.403-.95a1.63 1.63 0 0 1 .577-1.342l.135-.1c.32-.209.66-.247.83-.262.227-.02.507-.019.778-.019h3.176V4.399c0-.4-.002-.77.023-1.076.027-.32.087-.67.263-1.015A2.63 2.63 0 0 1 8.807 1.16 2.7 2.7 0 0 1 9.822.898c.306-.025.676-.023 1.078-.023h2.2c.402 0 .772-.002 1.078.023.32.027.67.087 1.015.263.494.251.896.653 1.147 1.147.176.345.236.695.262 1.015.026.306.024.675.024 1.076z"
      />
    </svg>
  );
}
